module.exports = __webpack_public_path__ + "static/media/16UNODC11.e64c2ba3.jpg";